<template>
	<v-card class="search-results-card" elevation="0">
		<div
			class="results-scroll"
			v-if="(searchResult.tasks && searchResult.tasks.length > 0) || (searchResult.rdis && searchResult.rdis.length > 0) || (searchResult.additionals && searchResult.additionals.length > 0)"
		>
			<v-tabs
				v-model="tab"
				fixed-tabs
				class="results-tabs mt-2"
				color="#5e85ef"
				height="28px"
			>
				<v-tab v-if="searchResult.tasks && searchResult.tasks.length > 0" class="caption tab-label">
					<v-icon x-small class="mr-1">mdi-clipboard-text-outline</v-icon>
					Tareas
				</v-tab>
				<v-tab v-if="searchResult.rdis && searchResult.rdis.length > 0" class="caption tab-label">
					<v-icon x-small class="mr-1">mdi-file-document-multiple-outline</v-icon>
					RDI
				</v-tab>
				<v-tab v-if="searchResult.additionals && searchResult.additionals.length > 0" class="caption tab-label">
					<v-icon x-small class="mr-1">mdi-notebook-plus-outline</v-icon>
					Adicionales
				</v-tab>
				<v-tab v-if="searchResult.entregas && searchResult.entregas.length > 0" class="caption tab-label">
					<v-icon x-small class="mr-1">mdi-format-list-checks</v-icon>
					Entregas
				</v-tab>
			</v-tabs>

			<v-divider class="mb-1"></v-divider>

			<v-tabs-items v-model="tab">
				<!-- TAREAS -->
				<v-tab-item v-if="searchResult.tasks && searchResult.tasks.length > 0">
					<div
						v-for="(tarea, index) in searchResult.tasks"
						:key="index"
						class="result-row"
						:class="{ 'result-row--selected': isSelected(tarea, 'task') }"
						@click="selectAssociation({...tarea, ...{type: 'task'}})"
					>
						<div class="result-row__info">
							<div class="d-flex align-center mb-1">
								<span class="result-badge result-badge--task mr-2">{{ tarea.number }}</span>
								<span class="result-row__title">{{ tarea.title }}</span>
							</div>
							<p class="result-row__desc mb-0"><span v-html="tarea.description"></span></p>
						</div>
						<v-btn icon small class="result-row__action" @click.stop="isSelected(tarea, 'task') ? removeAssociation({...tarea, ...{type: 'task'}}) : selectAssociation({...tarea, ...{type: 'task'}})">
							<v-icon small :color="isSelected(tarea, 'task') ? '#e53e3e' : '#c5cfe8'">
								{{ isSelected(tarea, 'task') ? 'mdi-close' : 'mdi-plus' }}
							</v-icon>
						</v-btn>
					</div>
				</v-tab-item>

				<!-- RDI -->
				<v-tab-item v-if="searchResult.rdis && searchResult.rdis.length > 0">
					<div
						v-for="(rdi, index) in searchResult.rdis"
						:key="index"
						class="result-row"
						:class="{ 'result-row--selected': isSelected(rdi, 'rdi') }"
						@click="selectAssociation({...rdi, ...{type: 'rdi'}})"
					>
						<div class="result-row__info">
							<div class="d-flex align-center mb-1">
								<span class="result-badge result-badge--rdi mr-2">{{ rdi.number }}</span>
								<span class="result-row__title">{{ rdi.title }}</span>
							</div>
							<p class="result-row__desc mb-0"><span v-html="rdi.description"></span></p>
						</div>
						<v-btn icon small class="result-row__action" @click.stop="isSelected(rdi, 'rdi') ? removeAssociation({...rdi, ...{type: 'rdi'}}) : selectAssociation({...rdi, ...{type: 'rdi'}})">
							<v-icon small :color="isSelected(rdi, 'rdi') ? '#e53e3e' : '#c5cfe8'">
								{{ isSelected(rdi, 'rdi') ? 'mdi-close' : 'mdi-plus' }}
							</v-icon>
						</v-btn>
					</div>
				</v-tab-item>

				<!-- ADICIONALES -->
				<v-tab-item v-if="searchResult.additionals && searchResult.additionals.length > 0">
					<div
						v-for="(additional, index) in searchResult.additionals"
						:key="index"
						class="result-row"
						:class="{ 'result-row--selected': isSelected(additional, 'additional') }"
						@click="selectAssociation({...additional, ...{type: 'additional'}})"
					>
						<div class="result-row__info">
							<div class="d-flex align-center mb-1">
								<span class="result-badge result-badge--additional mr-2">{{ additional.number }}</span>
								<span class="result-row__title">{{ additional.title }}</span>
							</div>
						</div>
						<v-btn icon small class="result-row__action" @click.stop="isSelected(additional, 'additional') ? removeAssociation({...additional, ...{type: 'additional'}}) : selectAssociation({...additional, ...{type: 'additional'}})">
							<v-icon small :color="isSelected(additional, 'additional') ? '#e53e3e' : '#c5cfe8'">
								{{ isSelected(additional, 'additional') ? 'mdi-close' : 'mdi-plus' }}
							</v-icon>
						</v-btn>
					</div>
				</v-tab-item>

				<!-- ENTREGAS -->
				<v-tab-item v-if="searchResult.entregas && searchResult.entregas.length > 0">
					<div
						v-for="(entrega, index) in searchResult.entregas"
						:key="index"
						class="result-row"
						:class="{ 'result-row--selected': isSelected(entrega, 'entrega') }"
						@click="selectAssociation({...entrega, ...{type: 'entrega'}})"
					>
						<div class="result-row__info">
							<div class="d-flex align-center mb-1">
								<span class="result-badge result-badge--entrega mr-2">{{ entrega.id }}</span>
								<span class="result-row__title">{{ entrega.title }}</span>
							</div>
						</div>
						<v-btn icon small class="result-row__action" @click.stop="isSelected(entrega, 'entrega') ? removeAssociation({...entrega, ...{type: 'entrega'}}) : selectAssociation({...entrega, ...{type: 'entrega'}})">
							<v-icon small :color="isSelected(entrega, 'entrega') ? '#e53e3e' : '#c5cfe8'">
								{{ isSelected(entrega, 'entrega') ? 'mdi-close' : 'mdi-plus' }}
							</v-icon>
						</v-btn>
					</div>
				</v-tab-item>
			</v-tabs-items>
		</div>

		<!-- Empty state -->
		<div v-else-if="!searching" class="empty-state">
			<v-icon color="#c5cfe8" size="28">mdi-link-variant-off</v-icon>
			<p class="empty-state__text mt-2 mb-0">Sin resultados</p>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'AssociationSearchResult',
	props: {
		closeResults: {
			type: Function
		},
		removeAssociation: {
			type: Function
		},
		searchResult: {
			type: Object
		},
		searching: {
			type: Boolean,
			default: true
		},
		selectedItems: {
			type: Array,
			default: () => []
		}
	},
	data: () => ({
		tab: null
	}),
	methods: {
		isSelected(item, type){
			return this.selectedItems.some((selected) => selected.id == item.id && type == selected.type)
		},
		selectAssociation(association){
			if(this.isSelected(association, association.type)){
				return
			}
			this.closeResults(association)
		}
	}
};
</script>

<style scoped>
.search-results-card {
	border-radius: 10px !important;
	overflow: hidden;
	border: 1px solid #e8edf8;
	margin-top: 8px;
}

.results-scroll {
	max-height: 320px;
	overflow-y: auto;
}

.results-scroll::-webkit-scrollbar {
	width: 4px;
}
.results-scroll::-webkit-scrollbar-track {
	background: #f0f4ff;
}
.results-scroll::-webkit-scrollbar-thumb {
	background: #c5d3f8;
	border-radius: 4px;
}

/* Tabs */
.results-tabs /deep/ .v-tab {
	text-transform: none;
	letter-spacing: 0;
	font-size: 11px;
	min-width: 0;
	padding: 0 10px;
}
.results-tabs /deep/ .v-tabs-slider {
	height: 2px;
	border-radius: 2px;
}

/* Result rows */
.result-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 7px 10px;
	border-bottom: 1px solid #f0f4ff;
	cursor: pointer;
	transition: background 0.12s;
}

.result-row:last-child {
	border-bottom: none;
}

.result-row:hover {
	background: #f5f8ff;
}

.result-row--selected {
	background: #edf2ff;
}

.result-row__info {
	flex: 1;
	min-width: 0;
}

.result-row__title {
	font-size: 11.5px;
	font-weight: 600;
	color: #2d3a5c;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 260px;
	display: block;
}

.result-row__desc {
	font-size: 10.5px;
	color: #8a97b5;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 300px;
	margin-bottom: 0 !important;
}

.result-row__desc /deep/ p {
	margin-bottom: 0 !important;
}

.result-row__action {
	flex-shrink: 0;
	margin-left: 4px;
}

/* Badges by type */
.result-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	font-size: 10px;
	font-weight: 700;
	padding: 1px 7px;
	color: #fff;
	flex-shrink: 0;
	min-width: 22px;
}

.result-badge--task {
	background: #5e85ef;
}

.result-badge--rdi {
	background: #48bb78;
}

.result-badge--additional {
	background: #ed8936;
}
.result-badge--entrega {
	background: #9f7aea;
}
/* Empty state */
.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px;
}

.empty-state__text {
	font-size: 12px;
	color: #a0aec0;
}
</style>